import { fetchReferralInfo, registerReferrer } from "@/apis/lendingRequests"
import { solanaTokenOraclePricesAtom } from "@/atoms/priceState"
import { referralAtom, referralFirstLoadingAtom } from "@/atoms/referralState"
import { solanaConnection } from "@/atoms/settings"
import Footer from "@/components/footer"
import Header from "@/components/header"
import useWalletConnect from "@/hooks/useWalletConnect"
import { REFERRAL_SEARCH_PARAM } from "@/utils/constants"
import { Box } from "@mui/material"
import { BlockchainNetwork, fetchPricesByMints, getSolanaMintOracleKeys } from "@renec-foundation/relend-adapter"
import { useAtom, useSetAtom } from "jotai"
import { useSearchParams } from "next/navigation"
import { ReactNode, useEffect } from "react"
import { useQuery } from "react-query"
import { TransitionsSnackbar } from "../transitionsSnackbar"
interface LayoutProps {
  children: ReactNode
}

const NO_REFERRER = ""

const Layout = ({ children }: LayoutProps) => {
  const { address, network } = useWalletConnect()
  const searchParams = useSearchParams()
  const { data: dataReferralInfo, refetch: refetchReferralInfo } = useQuery(
    ["fetchReferralInfo", network, address],
    () => fetchReferralInfo(network, address),
  )
  const [referral, setReferral] = useAtom(referralAtom)
  const [referralFirstLoading, setReferralFirstLoading] = useAtom(referralFirstLoadingAtom)
  const setSolanaTokenOraclePrices = useSetAtom(solanaTokenOraclePricesAtom)

  useEffect(() => {
    const submitReferrer = async () => {
      const referralCode = searchParams.get(REFERRAL_SEARCH_PARAM)
      if (referralCode && referralFirstLoading && referral.referrer === NO_REFERRER && address) {
        await registerReferrer(network, referralCode, address)
        refetchReferralInfo()
      }
    }
    submitReferrer()
  }, [searchParams, address, referralFirstLoading, referral, refetchReferralInfo, network])

  useEffect(() => {
    if (dataReferralInfo && !dataReferralInfo?.error) {
      setReferral(dataReferralInfo)
      setReferralFirstLoading(true)
    }
  }, [dataReferralInfo, setReferral, setReferralFirstLoading])

  useEffect(() => {
    const solanaOracleConfigs = getSolanaMintOracleKeys()
    fetchPricesByMints(BlockchainNetwork.SOLANA, solanaOracleConfigs, solanaConnection)
      .then((pricesData) => {
        setSolanaTokenOraclePrices(pricesData)
      })
      .catch((err) => console.error(err))
  }, [setSolanaTokenOraclePrices])

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Header position={"absolute"} />
      {children}
      <TransitionsSnackbar />
      <Footer />
    </Box>
  )
}

export default Layout
